import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js